import { Box, Collapse, List, ListItemButton } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import React, { useEffect, useState } from "react";
import { getFriendsList } from "../../../../components/Shared/Utils/index.js";
import FetchDateDisplay from "../fetchDateDisplay/fetchDateDisplay.component.js";

const FriendsList = ({
  accessToken,
  setDisplayError,
  setPopupType,
  setShowPopup,
  isUserOnIos,
}) => {
  const [friends, setFriends] = useState(
    JSON.parse(localStorage.getItem("friendsList")) || []
  );
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);
  const [lastFetchDate, setLastFetchDate] = useState(() => {
    const fetchDate = localStorage.getItem("fetchDateOfFriendsList");
    return fetchDate ? new Date(fetchDate) : null;
  });

  const handleGetFriendsList = async () => {
    setLoading(true);
    try {
      const result = await getFriendsList(accessToken);
      if (result === null) {
        const savedFriends =
          JSON.parse(localStorage.getItem("friendsList")) || [];
        setFriends(savedFriends);
      } else {
        setDisplayError(result);
        setFriends([]);
      }
      const now = new Date();
      setLastFetchDate(now);
      localStorage.setItem("fetchDateOfFriendsList", now.toISOString());
    } catch (error) {
      console.error("Failed to fetch friends list:", error);
      setDisplayError("Failed to fetch friends list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetFriendsList();
  }, []);

  // useEffect(() => {
  //   const now = new Date();
  //   const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
  //   const timeSinceLastFetch = lastFetchDate
  //     ? now - lastFetchDate.getTime()
  //     : Infinity;

  //   if (timeSinceLastFetch > oneHour) {
  //     handleGetFriendsList();
  //   } else {
  //     const savedFriends =
  //       JSON.parse(localStorage.getItem("friendsList")) || [];
  //     setFriends(savedFriends);
  //   }
  // }, [lastFetchDate]);

  // const handleToggleExpand = (index) => {
  //   setExpanded(expanded === index ? null : index);
  // };

  return (
    <div className="FriendsListTabDisplay">
      <Box
        className="friends-list-container"
        sx={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "60vh",
          overflow: "auto",
        }}
      >
        {
          <List>
            {friends.length === 0 && !loading ? (
              <div style={{ textAlign: "center" }}>
                <h3 style={{ paddingTop: "0rem", margin: "0rem" }}>
                  no friends yet{" "}
                </h3>
                <p>click on the REQUESTS tab</p>
                <p>to add your first friend</p>
              </div>
            ) : (
              friends.map((friend, index) => (
                <React.Fragment key={index}>
                  <ListItemButton
                    sx={{
                      pl: 1,
                      border: "var(--border)",
                      borderRadius: ".5rem",
                      padding: "1rem",
                      marginBottom: ".5rem",
                      display: "flex",
                      flexDirection: "column",
                      maxWidth: "35rem",
                    }}
                    // onClick={() => handleToggleExpand(index)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        marginBottom: ".5rem",
                      }}
                    >
                      <Box sx={{ mb: 1 }}>
                        <div>{`${friend.username}`}</div>
                        <br />
                      </Box>

                      <Box sx={{ textAlign: "right" }}>
                        <div>{`current streak: ${friend.currentDailyStreak}`}</div>

                        {friend.currentDailyStreak !== 0 &&
                        friend.currentDailyStreak ===
                          friend.highestDailyStreak ? (
                          <span
                            onClick={() => {
                              setShowPopup(true);
                              setPopupType("statBadgeTrophy");
                            }}
                            style={{ fontSize: "10px" }}
                          >
                            🏆
                          </span>
                        ) : (
                          <div>{`highest streak: ${friend.highestDailyStreak}`}</div>
                        )}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "0",
                        width: "100%",
                        margin: 0,
                      }}
                    >
                      <LinearProgress
                        sx={{ width: "100%" }}
                        variant="determinate"
                        value={friend.currentDailyCompletePercentage}
                      />
                    </Box>

                    <Collapse in={expanded === index}>
                      <Box sx={{ mt: 2 }}>
                        {/* friends' payments will go here */}
                      </Box>
                    </Collapse>
                  </ListItemButton>
                </React.Fragment>
              ))
            )}
          </List>
        }
      </Box>
      {lastFetchDate && (
        <FetchDateDisplay
          lastFetchDate={lastFetchDate}
          handleGetFriendsList={handleGetFriendsList}
          isUserOnIos={isUserOnIos}
        />
      )}
    </div>
  );
};

export default FriendsList;
